/* tslint:disable */
/* eslint-disable */
/**
 * CAST.AI API documentation
 * ### Feature maturity indicators (may appear on resources, operations and request/response fields)  - **(BETA)** - new or experimental features, subject to change  - **(Deprecated)** - outdated or replaced features (a reason and removal date will be provided in the description) 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * ProtocolType specifies the protocol type used by the database.
 * @export
 * @enum {string}
 */

export const DboV1CacheGroupProtocolType = {
    Unspecified: 'Unspecified',
    PostgreSQL: 'PostgreSQL',
    MySQL: 'MySQL',
    Oracle: 'Oracle'
} as const;

export type DboV1CacheGroupProtocolType = typeof DboV1CacheGroupProtocolType[keyof typeof DboV1CacheGroupProtocolType];



